import { BigNumber } from "@ethersproject/bignumber";
import { FallbackProvider } from "@ethersproject/providers";
import { PopulatedTransaction } from "ethers";

/**
 * Extra buffer added to the gas estimate as a percentage (i.e. extra 20%)
 */
const DEFAULT_GAS_BUFFER = 30;

export const getGasOverride = async (
  fallbackProvider: FallbackProvider,
  tx: PopulatedTransaction,
  buffer = DEFAULT_GAS_BUFFER
): Promise<{ gasLimit?: BigNumber }> => {
  try {
    const estimatedGas = await fallbackProvider.estimateGas(tx);

    const adjustedGas = estimatedGas.add(estimatedGas.mul(buffer).div(100));

    return { gasLimit: adjustedGas };
  } catch (err) {
    return {};
  }
};
